import { AlertCircle, RefreshCw, Home } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface ErrorFallbackProps {
  error: Error
  resetErrorBoundary: () => void
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card max-w-md text-center">
        <AlertCircle className="mx-auto mb-4 text-red-500" size={64} />
        <h2 className="text-2xl font-bold mb-2">오류가 발생했습니다</h2>
        <p className="text-gray-600 mb-4">
          {error.message || '알 수 없는 오류가 발생했습니다.'}
        </p>
        <div className="space-y-2">
          <button
            onClick={resetErrorBoundary}
            className="btn-primary w-full"
          >
            <RefreshCw className="inline mr-2" size={16} />
            다시 시도
          </button>
          <button
            onClick={() => navigate('/')}
            className="btn-secondary w-full"
          >
            <Home className="inline mr-2" size={16} />
            홈으로 이동
          </button>
        </div>
        {import.meta.env.DEV && (
          <details className="mt-4 text-left">
            <summary className="cursor-pointer text-sm text-gray-500">상세 정보</summary>
            <pre className="mt-2 text-xs bg-gray-100 p-2 rounded overflow-auto">
              {error.stack}
            </pre>
          </details>
        )}
      </div>
    </div>
  )
}

